import * as Yup from 'yup';

export const styleListSchema = Yup.object({
  Description: Yup.string().required('Description is required'),
});
